import React, { Component } from "react";
import styled from "styled-components";
import { push } from "connected-react-router";
import { connect } from "react-redux";

import appUrls from "../config/appUrls";

import logo from "../assets/images/logo.png";
import KPIIcon from "../components/icons/KPIs";
import ChannelIcon from "../components/icons/Channels";
import HomeIcon from "../components/icons/Home";
import ServicesIcon from "../components/icons/Services";
import ServiceCentersIcon from "../components/icons/ServiceCenters";
import MoonIcon from "../components/icons/Moon";
import SunIcon from "../components/icons/Sun";

const SideNav = styled.div`
  height: 100vh;
  width: 5%;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: ${props => props.theme.backgroundSecondary};
  transition: background-color ease 1s;
  overflow-x: hidden;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (min-width: 1800px) {
    width: 4.6%;
  }

  @media (max-width: 575px) {
    height: 12.5vh;
    width: 100%;
    top: inherit;
    bottom: 0;
    justify-content: center;
  z-index: 5;
    /* background-color: ${props => props.theme.backgroundTertiary}; */
  }
`;

const Logo = styled.img`
  width: 60%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 60%;
  object-fit: cover;
  @media (max-width: 575px) {
    display: none;
  }
`;

const Icon = styled.div`
  display: block;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
`;

const Title = styled.div`
  line-height: 17px;
  display: block;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  color: ${props => props.theme.text};
  padding: 0px 5px;
  text-align: center;
  word-wrap: break-word;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 21px;
  }
`;

const NavContainer = styled.div`
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  @media (min-width: 1800px) {
    height: 67%;
  }

  @media (max-width: 575px) {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    height: 100%;
    align-items: center;
    flex-direction: row-reverse;
  }
`;

const ModeContainer = styled(Icon)`
  margin-bottom: 100%;
  cursor: pointer;
  @media (max-width: 575px) {
    display: none;
  }
`;

const Nav = styled.div`
  cursor: pointer;
`;

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 3
    };
  }

  componentDidMount() {
    this.handleRefresh();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pathname !== this.props.pathname) {
      this.handleRefresh();
    }
  }

  handleRefresh = () => {
    let selected = 3;
    switch (this.props.pathname) {
      case appUrls.KPIS: {
        selected = 1;
        break;
      }
      case appUrls.CHANNEL: {
        selected = 2;
        break;
      }
      case appUrls.HOME: {
        selected = 3;
        break;
      }
      case appUrls.SERVICES: {
        selected = 4;
        break;
      }
      case appUrls.SERVICE_CENTERS: {
        selected = 5;
        break;
      }
      default: {
        selected = 3;
        break;
      }
    }
    this.setState({ selected });
  };

  handleNavClick = chosen => {
    this.setState({ selected: chosen });
    switch (chosen) {
      case 1: {
        this.props.push(appUrls.KPIS);
        break;
      }
      case 2: {
        this.props.push(appUrls.CHANNEL);
        break;
      }
      case 3: {
        this.props.push(appUrls.HOME);
        break;
      }
      case 4: {
        this.props.push(appUrls.SERVICES);
        break;
      }
      case 5: {
        this.props.push(appUrls.SERVICE_CENTERS);
        break;
      }
    }
  };

  render() {
    const { selected } = this.state;
    const { style, onThemeSwitch, isDarkTheme } = this.props;
    return (
      <SideNav style={style}>
        <Logo src={logo} alt="Logo" srcset="" />
        <NavContainer>
          <Nav
            onClick={() => {
              this.handleNavClick(1);
            }}
          >
            <Icon>
              <KPIIcon selected={selected === 1} />
            </Icon>
            <Title>مؤشرات</Title>
          </Nav>
          <Nav
            onClick={() => {
              this.handleNavClick(2);
            }}
          >
            <Icon>
              <ChannelIcon selected={selected === 2} />
            </Icon>
            <Title>قنوات</Title>
          </Nav>
          <Nav
            onClick={() => {
              this.handleNavClick(3);
            }}
          >
            <Icon>
              <HomeIcon selected={selected === 3} />
            </Icon>
            <Title>الرئيسية</Title>
          </Nav>
          <Nav
            onClick={() => {
              this.handleNavClick(4);
            }}
          >
            <Icon>
              <ServicesIcon selected={selected === 4} />
            </Icon>
            <Title>خدمات</Title>
          </Nav>
          <Nav
            onClick={() => {
              this.handleNavClick(5);
            }}
          >
            <Icon>
              <ServiceCentersIcon selected={selected === 5} />
            </Icon>
            <Title>مراكز خدمة</Title>
          </Nav>
        </NavContainer>
        <ModeContainer onClick={onThemeSwitch}>
          {isDarkTheme ? <SunIcon /> : <MoonIcon />}
        </ModeContainer>
      </SideNav>
    );
  }
}

const mapStateToProps = state => ({
  pathname: state.router.location.pathname,
  isDarkTheme: state.themes.theme === "dark"
});

export default connect(
  mapStateToProps,
  { push }
)(SideMenu);
